import React from 'react';
import MainLayout from '../../components/MainLayout';
import DataFlowDashboard from '../../dataflow/components/dashboard/DataFlowDashboard';
import '@xyflow/react/dist/style.css';
import '../../dataflow/styles/theme.css';
import '../../dataflow/styles/dfv.css';
import '../../dataflow/components/flow/flow.css';
import './EnterpriseDataFlow.css';

/**
 * 전사 모니터링 > 데이터 수집 흐름 (디자인: C:\tmp\smart_injection_monitor_UX\데이터 수집흐름\*.png)
 *
 * 다른 화면과 같은 MainLayout(상단 헤더·좌측 메뉴) 안에 들어간다. 헤더의 보기 선택으로
 * 토폴로지 뷰(수집 파이프라인 그래프)와 조감도 뷰(공장 카드)를 오간다 (?view=aerial).
 *
 * 데이터: 백엔드 /dashboard/pipeline/snapshot 을 5초 주기로 폴링한다(dataflow/lib/pipeline-feed.js).
 * 설비별 샷 도착·가동 판정·적재 행 수·ETL 동기화·알람은 실측값이고, 수집기·Outbox·원시 테이블
 * 상태는 수집기가 서버에 보고하지 않아 도착 통계로 추정해 표시한다(노드 설명에 명시).
 * 조감도 뷰는 /dashboard/company-factory 를 쓴다. 자세한 매핑은 dataflow/README.md 참고.
 */
function EnterpriseDataFlow() {
  return (
    <MainLayout>
      <div className="dataflow-page dataflow-root">
        <DataFlowDashboard />
      </div>
    </MainLayout>
  );
}

export default EnterpriseDataFlow;
